module.exports = __webpack_public_path__ + "img/heatMap.ff49716e.svg";